import React from 'react';
import { CommandBar } from '@fluentui/react/lib/CommandBar';
import { useTranslation } from 'react-i18next';
import { messageService } from '../../../services/messageService';
import { useDispatch } from 'react-redux';
import { saveSMStateAttr } from '../../../reducers/standardMailReducer';

const CommandBarLeft = (props: { disable: boolean }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const getItems = () => {
    return [
      {
        key: 'new',
        text: t('new'),
        iconProps: { iconName: 'Add' },
        onClick: () => {
          messageService.sendMessage({ isNewSM: true });
          dispatch(saveSMStateAttr('isClear', true));
          dispatch(saveSMStateAttr('formData', {}));
        },
        disabled: props.disable,
      },
    ];
  };

  return (
    <div>
      <CommandBar
        items={getItems()}
        ariaLabel="Use left and right arrow keys to navigate between commands"
      />
    </div>
  );
};

export default CommandBarLeft;
